import { DataScienceEnums } from 'dashboard-services/api/dataScience';

const getProvider = ({ value, withProvider = false, dependsOnParam = {} } = {}) => {
  if(withProvider) {
    return value?.provider ?? ""
  }

  if(dependsOnParam.valueType === DataScienceEnums.TASK_PARAM_VALUE_TYPE.DATA_SHARING_PROVIDER) {
    return dependsOnParam.value ?? dependsOnParam.defaultValue ?? ""
  }

  return undefined
}

export { getProvider }
